// Convert Web Components to React Components
import ReactLauncher from './ReactLauncher';
import * as serviceWorker from './serviceWorker';

// Components
import ChatRoom from './components/ChatRoom/ChatRoom';
import Simulator from './components/Simulator';


// Make Components Accessible
ReactLauncher([
    {tagName: 'ChatRoom', component: ChatRoom},
    {tagName: 'Simulator', component: Simulator},
]);

// Service Worker
serviceWorker.unregister();
